// import React, { useState, useEffect } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import {
//   Lock,
//   Unlock,
//   Save,
//   AlertTriangle,
//   Users,
//   RefreshCw,
//   Trash2,
//   CheckSquare,
//   Shield,
//   Search,
//   ChevronDown,
//   Eye,
//   UserCheck,
//   Filter
// } from 'lucide-react'
// import { fetchAllUsers } from '../../store/slices/authSlice'
// import {
//   fetchAllUsersPermissions,
//   fetchAvailableMenuItems,
//   updateUserPerms,
//   bulkUpdatePerms,
//   resetUserPerms
// } from '../../store/slices/permissionSlice'

// const AccessManagement = () => {
//   const dispatch = useDispatch()

//   // Redux state selectors
//   const {
//     allUsersPermissions = [],
//     availableMenuItems = [],
//     loading = false,
//     error = null
//   } = useSelector(state => state.permissions || {})

//   const { users = [] } = useSelector(state => state.auth || {})

//   // Local state
//   const [selectedUsers, setSelectedUsers] = useState([])
//   const [selectedRole, setSelectedRole] = useState('Employee')
//   const [bulkMode, setBulkMode] = useState(false)
//   const [unsavedChanges, setUnsavedChanges] = useState(new Set())
//   const [localPermissions, setLocalPermissions] = useState({})
//   const [searchTerm, setSearchTerm] = useState('')

//   // Filter out Admin role
//   const roles = ['Employee', 'Customer', 'Investor']

//   // Initialize data on component mount
//   useEffect(() => {
//     dispatch(fetchAllUsers())
//     dispatch(fetchAllUsersPermissions())
//     dispatch(fetchAvailableMenuItems())
//   }, [dispatch])

//   // Update local permissions when Redux data changes
//   useEffect(() => {
//     const permissionsMap = {}
//     allUsersPermissions.forEach(user => {
//       // Ensure each user has a valid permissions structure
//       if (!user.permissions?.menuPermissions) {
//         // Create empty permissions structure for new users
//         permissionsMap[user.userId] = []
//       } else {
//         permissionsMap[user.userId] = user.permissions.menuPermissions
//       }
//     })
//     setLocalPermissions(permissionsMap)
//   }, [allUsersPermissions])

//   // Filter users by selected role and search term
//   const filteredUsers = allUsersPermissions
//     .filter(user => user.role === selectedRole)
//     .filter(user =>
//       user.username.toLowerCase().includes(searchTerm.toLowerCase())
//     )

//   // Get selected user data
//   const getSelectedUserData = () => {
//     if (selectedUsers.length === 1) {
//       return filteredUsers.find(user => user.userId === selectedUsers[0])
//     }
//     return null
//   }

//   const togglePermission = (userId, menuId) => {
//     setLocalPermissions(prev => {
//       const userPerms = prev[userId] || []
//       const menuIndex = userPerms.findIndex(
//         menu => menu && menu.menuId === menuId
//       )

//       let updatedPerms
//       if (menuIndex !== -1) {
//         // Update existing menu permission
//         updatedPerms = userPerms.map(menu =>
//           menu && menu.menuId === menuId
//             ? { ...menu, hasAccess: !menu.hasAccess }
//             : menu
//         )
//       } else {
//         // Add new menu permission
//         const menuItem = availableMenuItems.find(
//           item => item && item.menuId === menuId
//         )
//         if (menuItem) {
//           updatedPerms = [...userPerms, { ...menuItem, hasAccess: true }]
//         } else {
//           updatedPerms = userPerms
//         }
//       }

//       return { ...prev, [userId]: updatedPerms }
//     })

//     setUnsavedChanges(prev => new Set([...prev, userId]))
//   }

//   // Toggle submenu permission
//   // const toggleSubMenuPermission = (userId, menuId, subMenuId) => {
//   //   setLocalPermissions((prev) => {
//   //     const userPerms = prev[userId] || [];
//   //     const updatedPerms = userPerms.map((menu) => {
//   //       if (menu.menuId === menuId) {
//   //         const updatedSubMenus =
//   //           menu.subMenuPermissions?.map((subMenu) =>
//   //             subMenu.subMenuId === subMenuId
//   //               ? { ...subMenu, hasAccess: !subMenu.hasAccess }
//   //               : subMenu
//   //           ) || [];

//   //         return { ...menu, subMenuPermissions: updatedSubMenus };
//   //       }
//   //       return menu;
//   //     });

//   //     return { ...prev, [userId]: updatedPerms };
//   //   });

//   //   setUnsavedChanges((prev) => new Set([...prev, userId]));
//   // };

//   const toggleSubMenuPermission = (userId, menuId, subMenuId) => {
//     setLocalPermissions(prev => {
//       const userPerms = prev[userId] || []
//       const updatedPerms = userPerms.map(menu => {
//         if (menu.menuId === menuId) {
//           const updatedSubMenus =
//             menu.subMenuPermissions?.map(subMenu =>
//               subMenu.subMenuId === subMenuId
//                 ? { ...subMenu, hasAccess: !subMenu.hasAccess }
//                 : subMenu
//             ) || []

//           // Check if any submenu is now enabled
//           const anySubMenuEnabled = updatedSubMenus.some(sm => sm.hasAccess)

//           // Auto-enable main menu if any submenu is enabled
//           return {
//             ...menu,
//             subMenuPermissions: updatedSubMenus,
//             hasAccess: anySubMenuEnabled ? true : menu.hasAccess
//           }
//         }
//         return menu
//       })

//       return { ...prev, [userId]: updatedPerms }
//     })

//     setUnsavedChanges(prev => new Set([...prev, userId]))
//   }

//   const saveUserPermissions = async userId => {
//     const menuPermissions = localPermissions[userId] || []

//     try {
//       await dispatch(
//         updateUserPerms({
//           userId,
//           menuPermissions
//         })
//       ).unwrap()

//       setUnsavedChanges(prev => {
//         const newSet = new Set(prev)
//         newSet.delete(userId)
//         return newSet
//       })

//       // Refresh the data after successful save
//       dispatch(fetchAllUsersPermissions())
//     } catch (error) {
//       console.error('Failed to save permissions:', error)
//       // Optionally show error message to user
//     }
//   }

//   // Reset user permissions to default
//   const resetUserPermissions = async userId => {
//     try {
//       await dispatch(resetUserPerms(userId)).unwrap()
//       setUnsavedChanges(prev => {
//         const newSet = new Set(prev)
//         newSet.delete(userId)
//         return newSet
//       })

//       // Refresh the data after successful reset
//       dispatch(fetchAllUsersPermissions())
//     } catch (error) {
//       console.error('Failed to reset permissions:', error)
//     }
//   }

//   // Bulk update permissions
//   const bulkUpdatePermissions = async () => {
//     if (selectedUsers.length === 0) return

//     // Use the first selected user's permissions as template
//     const templatePermissions = localPermissions[selectedUsers[0]] || []

//     try {
//       await dispatch(
//         bulkUpdatePerms({
//           userIds: selectedUsers,
//           menuPermissions: templatePermissions
//         })
//       ).unwrap()

//       setSelectedUsers([])
//       setBulkMode(false)
//       setUnsavedChanges(new Set())
//     } catch (error) {
//       console.error('Failed to bulk update permissions:', error)
//     }
//   }

//   // Toggle user selection for bulk operations
//   const toggleUserSelection = userId => {
//     setSelectedUsers(prev =>
//       prev.includes(userId)
//         ? prev.filter(id => id !== userId)
//         : [...prev, userId]
//     )
//   }

//   // Check if menu has access
//   const hasMenuAccess = (userId, menuId) => {
//     const userPerms = localPermissions[userId] || []
//     const menu = userPerms.find(m => m && m.menuId === menuId)
//     return menu?.hasAccess || false
//   }

//   const hasSubMenuAccess = (userId, menuId, subMenuId) => {
//     const userPerms = localPermissions[userId] || []
//     const menu = userPerms.find(m => m && m.menuId === menuId)
//     const subMenu = menu?.subMenuPermissions?.find(
//       sm => sm && sm.subMenuId === subMenuId
//     )
//     return subMenu?.hasAccess || false
//   }

//   const selectedUserData = getSelectedUserData()

//   return (
//     <div className='bg-gradient-to-br from-slate-900/95 via-slate-950/95 to-slate-900/95 rounded-xl shadow-lg'>
//       {/* Header */}
//       <div className='bg-white/5 backdrop-blur-xl border-b border-white/10 rounded-xl shadow-lg'>
//         <div className='max-w-7xl mx-auto px-6 py-4'>
//           <div className='flex items-center justify-between'>
//             <div className='flex items-center space-x-4'>
//               <div className='w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center'>
//                 <Shield className='w-9 h-9 text-white' />
//               </div>
//               <div>
//                 <h1 className='lg:text-5xl text-lg font-semibold text-white'>
//                   Access management
//                 </h1>
//                 <p className='text-md text-slate-400'>
//                   Manage user permissions and roles
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className='max-w-7xl mx-auto px-6 py-8'>
//         {/* Error Display */}
//         {error && (
//           <div className='mb-6 p-4 bg-red-500/10 border border-red-500/20 rounded-xl flex items-center space-x-3'>
//             <AlertTriangle className='text-red-400 flex-shrink-0' />
//             <p className='text-red-300'>{error}</p>
//           </div>
//         )}

//         {/* Controls */}
//         <div className='mb-8 bg-white/5 backdrop-blur-xl rounded-xl border border-white/10'>
//           <div className='p-6'>
//             <div className='flex flex-col lg:flex-row lg:items-center justify-between gap-6'>
//               {/* Left Side Controls */}
//               <div className='flex flex-col sm:flex-row items-start sm:items-center gap-4'>
//                 {/* Role Filter */}
//                 <div className='flex items-center space-x-3'>
//                   <Filter className='w-5 h-5 text-teal-300' />
//                   <div className='relative'>
//                     <select
//                       value={selectedRole}
//                       onChange={e => {
//                         setSelectedRole(e.target.value)
//                         setSelectedUsers([])
//                         setBulkMode(false)
//                       }}
//                       className='appearance-none bg-white/5 border border-white/20 rounded-lg px-4 py-2.5 pr-10 text-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent min-w-[140px]'
//                     >
//                       {roles.map(role => (
//                         <option
//                           key={role}
//                           value={role}
//                           className='bg-slate-800'
//                         >
//                           {role}
//                         </option>
//                       ))}
//                     </select>
//                     <ChevronDown className='absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none' />
//                   </div>
//                 </div>

//                 {/* Search */}
//                 <div className='relative'>
//                   <Search className='absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400' />
//                   <input
//                     type='text'
//                     placeholder='Search users...'
//                     value={searchTerm}
//                     onChange={e => setSearchTerm(e.target.value)}
//                     className='pl-10 pr-4 py-2.5 bg-white/5 border border-white/20 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent min-w-[200px]'
//                   />
//                 </div>
//               </div>

//               {/* Right Side Controls */}
//               <div className='flex items-center gap-3'>
//                 <button
//                   onClick={() => {
//                     setBulkMode(!bulkMode)
//                     setSelectedUsers([])
//                   }}
//                   className={`px-4 py-2.5 rounded-lg flex items-center space-x-2 font-medium transition-all ${
//                     bulkMode
//                       ? 'bg-teal-600 text-white shadow-lg shadow-teal-600/25'
//                       : 'bg-white/5 text-teal-300 hover:bg-white/10 border border-white/20'
//                   }`}
//                 >
//                   <Users className='w-4 h-4' />
//                   <span>Bulk actions</span>
//                 </button>

//                 {bulkMode && selectedUsers.length > 0 && (
//                   <button
//                     onClick={bulkUpdatePermissions}
//                     disabled={loading}
//                     className='px-4 py-2.5 bg-teal-600 hover:bg-teal-700 text-white rounded-lg flex items-center space-x-2 font-medium transition-all disabled:opacity-50 shadow-lg shadow-teal-600/25'
//                   >
//                     {loading ? (
//                       <RefreshCw className='w-4 h-4 animate-spin' />
//                     ) : (
//                       <Save className='w-4 h-4' />
//                     )}
//                     <span>Apply to {selectedUsers.length} users</span>
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className='grid grid-cols-1 xl:grid-cols-4 gap-8'>
//           {/* Users List */}
//           <div className='xl:col-span-1'>
//             <div className='bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 overflow-hidden'>
//               <div className='p-6 border-b border-white/10'>
//                 <div className='flex items-center justify-between'>
//                   <h2 className='text-lg font-semibold text-white'>
//                     {selectedRole} users
//                   </h2>
//                   <span className='px-3 py-1 bg-teal-500/20 text-teal-300 text-sm font-medium rounded-full'>
//                     {filteredUsers.length}
//                   </span>
//                 </div>
//               </div>

//               <div className='max-h-[600px] overflow-y-auto'>
//                 {filteredUsers.map((user, index) => (
//                   <div
//                     key={user.userId}
//                     className={`group relative p-4 hover:bg-white/5 transition-all cursor-pointer ${
//                       selectedUsers.includes(user.userId)
//                         ? 'bg-teal-500/10 border-r-2 border-teal-500'
//                         : ''
//                     } ${
//                       index !== filteredUsers.length - 1
//                         ? 'border-b border-white/5'
//                         : ''
//                     }`}
//                     onClick={() => {
//                       if (bulkMode) {
//                         toggleUserSelection(user.userId)
//                       } else {
//                         setSelectedUsers([user.userId])
//                       }
//                     }}
//                   >
//                     <div className='flex items-center space-x-3'>
//                       {bulkMode && (
//                         <div className='flex-shrink-0'>
//                           {selectedUsers.includes(user.userId) ? (
//                             <div className='w-5 h-5 bg-teal-500 rounded border-2 border-teal-500 flex items-center justify-center'>
//                               <CheckSquare className='w-3 h-3 text-white' />
//                             </div>
//                           ) : (
//                             <div className='w-5 h-5 border-2 border-slate-500 rounded'></div>
//                           )}
//                         </div>
//                       )}

//                       <div className='w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0'>
//                         <span className='text-white font-semibold text-sm'>
//                           {user.username.charAt(0).toUpperCase()}
//                         </span>
//                       </div>

//                       <div className='flex-1 min-w-0'>
//                         <p className='font-medium text-white truncate'>
//                           {user.username}
//                         </p>
//                         <div className='flex items-center space-x-2 mt-1'>
//                           <span className='text-xs text-slate-400'>
//                             {user.role}
//                           </span>
//                           {user.designation && (
//                             <>
//                               <span className='text-xs text-slate-600'>•</span>
//                               <span className='text-xs text-slate-400 truncate'>
//                                 {user.designation}
//                               </span>
//                             </>
//                           )}
//                         </div>
//                       </div>

//                       <div className='flex-shrink-0 flex items-center space-x-2'>
//                         {unsavedChanges.has(user.userId) && (
//                           <div className='w-2 h-2 bg-amber-500 rounded-full animate-pulse'></div>
//                         )}
//                         <Eye className='w-4 h-4 text-slate-500 opacity-0 group-hover:opacity-100 transition-opacity' />
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//                 {filteredUsers.length === 0 && (
//                   <div className='p-8 text-center'>
//                     <UserCheck className='w-12 h-12 text-slate-600 mx-auto mb-3' />
//                     <p className='text-slate-400 font-medium'>No users found</p>
//                     <p className='text-slate-500 text-sm mt-1'>
//                       Try adjusting your search or filters
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Permissions Panel */}
//           <div className='xl:col-span-3'>
//             {selectedUsers.length === 0 ? (
//               <div className='bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 p-12 text-center'>
//                 <div className='w-20 h-20 bg-white/5 rounded-2xl flex items-center justify-center mx-auto mb-6'>
//                   <Shield className='w-10 h-10 text-slate-500' />
//                 </div>
//                 <h3 className='text-xl font-semibold text-white mb-3'>
//                   Select a user to manage permissions
//                 </h3>
//                 <p className='text-slate-400 max-w-md mx-auto'>
//                   Choose a user from the list to view and edit their access
//                   permissions, or use bulk mode to manage multiple users at
//                   once.
//                 </p>
//               </div>
//             ) : (
//               <div className='bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 overflow-hidden'>
//                 {/* Header */}
//                 <div className='p-6 border-b border-white/10'>
//                   <div className='flex items-center justify-between'>
//                     <div>
//                       <h2 className='text-xl font-semibold text-white mb-2'>
//                         {selectedUsers.length === 1
//                           ? `${selectedUserData?.username}'s permissions`
//                           : `Bulk edit permissions (${selectedUsers.length} users)`}
//                       </h2>
//                       {selectedUserData && (
//                         <div className='flex items-center space-x-4 text-sm text-slate-400'>
//                           <span className='flex items-center space-x-1'>
//                             <span>Role:</span>
//                             <span className='text-teal-300 font-medium'>
//                               {selectedUserData.role}
//                             </span>
//                           </span>
//                           <span className='text-slate-600'>•</span>
//                           <span>
//                             Last modified:{' '}
//                             {selectedUserData.permissions?.lastModified
//                               ? new Date(
//                                   selectedUserData.permissions.lastModified
//                                 ).toLocaleDateString()
//                               : 'Never'}
//                           </span>
//                         </div>
//                       )}
//                     </div>

//                     {selectedUsers.length === 1 && (
//                       <div className='flex space-x-3'>
//                         <button
//                           onClick={() => {
//                             // Revert to original permissions from Redux state
//                             const originalUser = allUsersPermissions.find(
//                               u => u.userId === selectedUsers[0]
//                             )
//                             if (originalUser?.permissions?.menuPermissions) {
//                               setLocalPermissions(prev => ({
//                                 ...prev,
//                                 [selectedUsers[0]]:
//                                   originalUser.permissions.menuPermissions
//                               }))
//                             }
//                             // Remove from unsaved changes
//                             setUnsavedChanges(prev => {
//                               const newSet = new Set(prev)
//                               newSet.delete(selectedUsers[0])
//                               return newSet
//                             })
//                           }}
//                           disabled={
//                             loading || !unsavedChanges.has(selectedUsers[0])
//                           }
//                           className='px-4 py-2.5 bg-white/5 hover:bg-red-500/10 hover:text-red-400 text-slate-300 border border-white/20 rounded-lg flex items-center space-x-2 font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed'
//                         >
//                           <Trash2 className='w-4 h-4' />
//                           <span>Cancel</span>
//                         </button>
//                         <button
//                           onClick={() => saveUserPermissions(selectedUsers[0])}
//                           disabled={
//                             loading || !unsavedChanges.has(selectedUsers[0])
//                           }
//                           className='px-4 py-2.5 bg-teal-600 hover:bg-teal-700 disabled:bg-white/10 disabled:text-slate-500 text-white rounded-lg flex items-center space-x-2 font-medium transition-all shadow-lg shadow-teal-600/25'
//                         >
//                           {loading ? (
//                             <RefreshCw className='w-4 h-4 animate-spin' />
//                           ) : (
//                             <Save className='w-4 h-4' />
//                           )}
//                           <span>Save changes</span>
//                         </button>
//                         <button
//                           onClick={() => resetUserPermissions(selectedUsers[0])}
//                           disabled={loading}
//                           className='px-4 py-2.5 bg-white/5 hover:bg-red-500/10 hover:text-red-400 text-slate-300 border border-white/20 rounded-lg flex items-center space-x-2 font-medium transition-all'
//                         >
//                           <Trash2 className='w-4 h-4' />
//                           <span>Reset</span>
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Permissions Grid */}
//                 <div className='p-6'>
//                   <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
//                     {availableMenuItems
//                       .filter(menuItem => menuItem && menuItem.menuId) // Add filter to remove null/undefined items
//                       .map(menuItem => {
//                         const userId = selectedUsers[0]
//                         const hasAccess = hasMenuAccess(userId, menuItem.menuId)

//                         return (
//                           <div
//                             key={menuItem.menuId}
//                             className='bg-white/5 rounded-xl border border-white/10 overflow-hidden hover:bg-white/10 transition-all'
//                           >
//                             {/* Main Menu Item */}
//                             <div
//                               className='p-4 cursor-pointer'
//                               onClick={() =>
//                                 togglePermission(userId, menuItem.menuId)
//                               }
//                             >
//                               <div className='flex items-center justify-between'>
//                                 <div className='flex items-center space-x-3'>
//                                   <div
//                                     className={`w-6 h-6 rounded-lg flex items-center justify-center ${
//                                       hasAccess ? 'bg-teal-500' : 'bg-white/10'
//                                     }`}
//                                   >
//                                     {hasAccess ? (
//                                       <Unlock className='w-4 h-4 text-white' />
//                                     ) : (
//                                       <Lock className='w-4 h-4 text-slate-400' />
//                                     )}
//                                   </div>
//                                   <span
//                                     className={`font-medium ${
//                                       hasAccess
//                                         ? 'text-teal-300'
//                                         : 'text-slate-300'
//                                     }`}
//                                   >
//                                     {menuItem.label || 'Unnamed Menu'}
//                                   </span>
//                                 </div>
//                                 <div
//                                   className={`px-3 py-1 rounded-full text-xs font-medium ${
//                                     hasAccess
//                                       ? 'bg-teal-500/20 text-teal-300'
//                                       : 'bg-white/5 text-slate-400'
//                                   }`}
//                                 >
//                                   {hasAccess ? 'Granted' : 'Denied'}
//                                 </div>
//                               </div>
//                             </div>

//                             {/* Sub Menu Items */}
//                             {menuItem.subMenuPermissions &&
//                               Array.isArray(menuItem.subMenuPermissions) &&
//                               menuItem.subMenuPermissions.length > 0 && (
//                                 <div className='border-t border-white/5 bg-white/5'>
//                                   {menuItem.subMenuPermissions
//                                     .filter(
//                                       subMenuItem =>
//                                         subMenuItem && subMenuItem.subMenuId
//                                     ) // Add filter here too
//                                     .map(subMenuItem => {
//                                       const hasSubAccess = hasSubMenuAccess(
//                                         userId,
//                                         menuItem.menuId,
//                                         subMenuItem.subMenuId
//                                       )

//                                       return (
//                                         <div
//                                           key={subMenuItem.subMenuId}
//                                           className='px-4 py-3 border-b border-white/5 last:border-b-0 cursor-pointer hover:bg-white/5 transition-all'
//                                           onClick={() =>
//                                             toggleSubMenuPermission(
//                                               userId,
//                                               menuItem.menuId,
//                                               subMenuItem.subMenuId
//                                             )
//                                           }
//                                         >
//                                           <div className='flex items-center justify-between pl-4'>
//                                             <div className='flex items-center space-x-3'>
//                                               <div
//                                                 className={`w-4 h-4 rounded flex items-center justify-center ${
//                                                   hasSubAccess
//                                                     ? 'bg-teal-500'
//                                                     : 'bg-white/10'
//                                                 }`}
//                                               >
//                                                 {hasSubAccess ? (
//                                                   <Unlock className='w-3 h-3 text-white' />
//                                                 ) : (
//                                                   <Lock className='w-3 h-3 text-slate-400' />
//                                                 )}
//                                               </div>
//                                               <span
//                                                 className={`text-sm ${
//                                                   hasSubAccess
//                                                     ? 'text-teal-300'
//                                                     : 'text-slate-400'
//                                                 }`}
//                                               >
//                                                 {subMenuItem.label ||
//                                                   'Unnamed Submenu'}
//                                               </span>
//                                             </div>
//                                             <div
//                                               className={`w-2 h-2 rounded-full ${
//                                                 hasSubAccess
//                                                   ? 'bg-teal-500'
//                                                   : 'bg-slate-600'
//                                               }`}
//                                             ></div>
//                                           </div>
//                                         </div>
//                                       )
//                                     })}
//                                 </div>
//                               )}
//                           </div>
//                         )
//                       })}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default AccessManagement

import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Lock,
  Unlock,
  Save,
  AlertTriangle,
  Users,
  RefreshCw,
  Trash2,
  CheckSquare,
  Shield,
  Search,
  ChevronDown,
  Eye,
  UserCheck,
  Filter,
} from "lucide-react";
import { fetchAllUsers } from "../../store/slices/authSlice";
import {
  fetchAllUsersPermissions,
  fetchAvailableMenuItems,
  updateUserPerms,
  bulkUpdatePerms,
  resetUserPerms,
} from "../../store/slices/permissionSlice";

const getValidMenuItems = (menuItems) => {
  return menuItems.filter((item) => {
    return item && item.menuId && item.label;
  });
};

const AccessManagement = () => {
  const dispatch = useDispatch();

  const {
    allUsersPermissions = [],
    availableMenuItems = [],
    loading = false,
    error = null,
  } = useSelector((state) => state.permissions || {});

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedRole, setSelectedRole] = useState("Admin");
  const [bulkMode, setBulkMode] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(new Set());
  const [localPermissions, setLocalPermissions] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const roles = ["Admin", "Employee", "Customer", "Investor"];

  useEffect(() => {
    dispatch(fetchAllUsers());
    dispatch(fetchAllUsersPermissions());
    dispatch(fetchAvailableMenuItems());
  }, [dispatch]);

  useEffect(() => {
    const permissionsMap = {};
    allUsersPermissions.forEach((user) => {
      if (!user.permissions?.menuPermissions) {
        permissionsMap[user.userId] = [];
      } else {
        permissionsMap[user.userId] = user.permissions.menuPermissions;
      }
    });
    setLocalPermissions(permissionsMap);
  }, [allUsersPermissions]);

  const filteredUsers = useMemo(() => {
    return allUsersPermissions
      .filter((user) => user && user.role === selectedRole)
      .filter((user) =>
        user.username.toLowerCase().includes(searchTerm.toLowerCase()),
      );
  }, [allUsersPermissions, selectedRole, searchTerm]);

  const selectedUserData = useMemo(() => {
    if (selectedUsers.length === 1) {
      return filteredUsers.find((user) => user.userId === selectedUsers[0]);
    }
    return null;
  }, [selectedUsers, filteredUsers]);

  const hasMenuAccess = (userId, menuId) => {
    const userPerms = localPermissions[userId] || [];
    const menu = userPerms.find((m) => m && m.menuId === menuId);
    return menu?.hasAccess || false;
  };

  const hasSubMenuAccess = (userId, menuId, subMenuId) => {
    const userPerms = localPermissions[userId] || [];
    const menu = userPerms.find((m) => m && m.menuId === menuId);
    const subMenu = menu?.subMenuPermissions?.find(
      (sm) => sm && sm.subMenuId === subMenuId,
    );
    return subMenu?.hasAccess || false;
  };

  const togglePermission = (userId, menuId) => {
    setLocalPermissions((prev) => {
      const userPerms = prev[userId] || [];
      const validPerms = userPerms.filter((m) => m && m.menuId);

      const menuIndex = validPerms.findIndex((menu) => menu.menuId === menuId);

      let updatedPerms;
      if (menuIndex !== -1) {
        updatedPerms = validPerms.map((menu) =>
          menu.menuId === menuId
            ? { ...menu, hasAccess: !menu.hasAccess }
            : menu,
        );
      } else {
        const menuItem = getValidMenuItems(availableMenuItems).find(
          (item) => item.menuId === menuId,
        );
        if (menuItem) {
          updatedPerms = [...validPerms, { ...menuItem, hasAccess: true }];
        } else {
          updatedPerms = validPerms;
        }
      }

      return { ...prev, [userId]: updatedPerms };
    });

    setUnsavedChanges((prev) => new Set([...prev, userId]));
  };

  const toggleSubMenuPermission = (userId, menuId, subMenuId) => {
    setLocalPermissions((prev) => {
      const userPerms = prev[userId] || [];
      const validPerms = userPerms.filter((m) => m && m.menuId);

      const updatedPerms = validPerms.map((menu) => {
        if (menu && menu.menuId === menuId) {
          const updatedSubMenus =
            menu.subMenuPermissions?.map((subMenu) =>
              subMenu && subMenu.subMenuId === subMenuId
                ? { ...subMenu, hasAccess: !subMenu.hasAccess }
                : subMenu,
            ) || [];

          const anySubMenuEnabled = updatedSubMenus.some(
            (sm) => sm && sm.hasAccess,
          );

          return {
            ...menu,
            subMenuPermissions: updatedSubMenus,
            hasAccess: anySubMenuEnabled ? true : menu.hasAccess,
          };
        }
        return menu;
      });

      return { ...prev, [userId]: updatedPerms };
    });

    setUnsavedChanges((prev) => new Set([...prev, userId]));
  };

  const saveUserPermissions = async (userId) => {
    const menuPermissions = localPermissions[userId] || [];

    try {
      await dispatch(
        updateUserPerms({
          userId,
          menuPermissions,
        }),
      ).unwrap();

      setUnsavedChanges((prev) => {
        const newSet = new Set(prev);
        newSet.delete(userId);
        return newSet;
      });

      dispatch(fetchAllUsersPermissions());
    } catch (error) {
      console.error("Failed to save permissions:", error);
    }
  };

  const resetUserPermissions = async (userId) => {
    try {
      await dispatch(resetUserPerms(userId)).unwrap();
      setUnsavedChanges((prev) => {
        const newSet = new Set(prev);
        newSet.delete(userId);
        return newSet;
      });

      dispatch(fetchAllUsersPermissions());
    } catch (error) {
      console.error("Failed to reset permissions:", error);
    }
  };

  const bulkUpdatePermissions = async () => {
    if (selectedUsers.length === 0) return;

    const templatePermissions = localPermissions[selectedUsers[0]] || [];

    try {
      await dispatch(
        bulkUpdatePerms({
          userIds: selectedUsers,
          menuPermissions: templatePermissions,
        }),
      ).unwrap();

      setSelectedUsers([]);
      setBulkMode(false);
      setUnsavedChanges(new Set());
    } catch (error) {
      console.error("Failed to bulk update permissions:", error);
    }
  };

  const toggleUserSelection = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId],
    );
  };

  const getMenuItemsWithGrouping = (menuItems) => {
    const validItems = getValidMenuItems(menuItems);

    return {
      standard: validItems.filter(
        (item) =>
          item.menuId !== "user-info" && item.menuId !== "payments-paid",
      ),
      customerOnly: validItems.filter(
        (item) =>
          item.menuId === "user-info" || item.menuId === "payments-paid",
      ),
    };
  };

  return (
    <div className="bg-gradient-to-br from-slate-900/95 via-slate-950/95 to-slate-900/95 rounded-xl shadow-lg">
      <div className="bg-white/5 backdrop-blur-xl border-b border-white/10 rounded-xl shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center">
                <Shield className="w-9 h-9 text-white" />
              </div>
              <div>
                <h1 className="lg:text-5xl text-lg font-semibold text-white">
                  Access management
                </h1>
                <p className="text-md text-slate-400">
                  Manage user permissions and roles
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {error && (
          <div className="mb-6 p-4 bg-red-500/10 border border-red-500/20 rounded-xl flex items-center space-x-3">
            <AlertTriangle className="text-red-400 flex-shrink-0" />
            <p className="text-red-300">{error}</p>
          </div>
        )}

        <div className="mb-8 bg-white/5 backdrop-blur-xl rounded-xl border border-white/10">
          <div className="p-6">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="flex items-center space-x-3">
                  <Filter className="w-5 h-5 text-teal-300" />
                  <div className="relative">
                    <select
                      value={selectedRole}
                      onChange={(e) => {
                        setSelectedRole(e.target.value);
                        setSelectedUsers([]);
                        setBulkMode(false);
                      }}
                      className="appearance-none bg-white/5 border border-white/20 rounded-lg px-4 py-2.5 pr-10 text-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent min-w-[140px]"
                    >
                      {roles.map((role) => (
                        <option
                          key={role}
                          value={role}
                          className="bg-slate-800"
                        >
                          {role}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
                  </div>
                </div>

                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <input
                    type="text"
                    placeholder="Search users..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2.5 bg-white/5 border border-white/20 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent min-w-[200px]"
                  />
                </div>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={() => {
                    setBulkMode(!bulkMode);
                    setSelectedUsers([]);
                  }}
                  className={`px-4 py-2.5 rounded-lg flex items-center space-x-2 font-medium transition-all ${
                    bulkMode
                      ? "bg-teal-600 text-white shadow-lg shadow-teal-600/25"
                      : "bg-white/5 text-teal-300 hover:bg-white/10 border border-white/20"
                  }`}
                >
                  <Users className="w-4 h-4" />
                  <span>Bulk actions</span>
                </button>

                {bulkMode && selectedUsers.length > 0 && (
                  <button
                    onClick={bulkUpdatePermissions}
                    disabled={loading}
                    className="px-4 py-2.5 bg-teal-600 hover:bg-teal-700 text-white rounded-lg flex items-center space-x-2 font-medium transition-all disabled:opacity-50 shadow-lg shadow-teal-600/25"
                  >
                    {loading ? (
                      <RefreshCw className="w-4 h-4 animate-spin" />
                    ) : (
                      <Save className="w-4 h-4" />
                    )}
                    <span>Apply to {selectedUsers.length} users</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-4 gap-8">
          <div className="xl:col-span-1">
            <div className="bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 overflow-hidden">
              <div className="p-6 border-b border-white/10">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-semibold text-white">
                    {selectedRole} users
                  </h2>
                  <span className="px-3 py-1 bg-teal-500/20 text-teal-300 text-sm font-medium rounded-full">
                    {filteredUsers.length}
                  </span>
                </div>
              </div>

              <div className="max-h-[600px] overflow-y-auto">
                {filteredUsers.map((user, index) => (
                  <div
                    key={user.userId}
                    className={`group relative p-4 hover:bg-white/5 transition-all cursor-pointer ${
                      selectedUsers.includes(user.userId)
                        ? "bg-teal-500/10 border-r-2 border-teal-500"
                        : ""
                    } ${
                      index !== filteredUsers.length - 1
                        ? "border-b border-white/5"
                        : ""
                    }`}
                    onClick={() => {
                      if (bulkMode) {
                        toggleUserSelection(user.userId);
                      } else {
                        setSelectedUsers([user.userId]);
                      }
                    }}
                  >
                    <div className="flex items-center space-x-3">
                      {bulkMode && (
                        <div className="flex-shrink-0">
                          {selectedUsers.includes(user.userId) ? (
                            <div className="w-5 h-5 bg-teal-500 rounded border-2 border-teal-500 flex items-center justify-center">
                              <CheckSquare className="w-3 h-3 text-white" />
                            </div>
                          ) : (
                            <div className="w-5 h-5 border-2 border-slate-500 rounded"></div>
                          )}
                        </div>
                      )}

                      <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-semibold text-sm">
                          {user.username.charAt(0).toUpperCase()}
                        </span>
                      </div>

                      <div className="flex-1 min-w-0">
                        <p className="font-medium text-white truncate">
                          {user.username}
                        </p>
                        <div className="flex items-center space-x-2 mt-1">
                          <span className="text-xs text-slate-400">
                            {user.role}
                          </span>
                          {user.designation && (
                            <>
                              <span className="text-xs text-slate-600">•</span>
                              <span className="text-xs text-slate-400 truncate">
                                {user.designation}
                              </span>
                            </>
                          )}
                        </div>
                      </div>

                      <div className="flex-shrink-0 flex items-center space-x-2">
                        {unsavedChanges.has(user.userId) && (
                          <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></div>
                        )}
                        <Eye className="w-4 h-4 text-slate-500 opacity-0 group-hover:opacity-100 transition-opacity" />
                      </div>
                    </div>
                  </div>
                ))}

                {filteredUsers.length === 0 && (
                  <div className="p-8 text-center">
                    <UserCheck className="w-12 h-12 text-slate-600 mx-auto mb-3" />
                    <p className="text-slate-400 font-medium">No users found</p>
                    <p className="text-slate-500 text-sm mt-1">
                      Try adjusting your search or filters
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="xl:col-span-3">
            {selectedUsers.length === 0 ? (
              <div className="bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 p-12 text-center">
                <div className="w-20 h-20 bg-white/5 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <Shield className="w-10 h-10 text-slate-500" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  Select a user to manage permissions
                </h3>
                <p className="text-slate-400 max-w-md mx-auto">
                  Choose a user from the list to view and edit their access
                  permissions, or use bulk mode to manage multiple users at
                  once.
                </p>
              </div>
            ) : (
              <div className="bg-white/5 backdrop-blur-xl rounded-xl border border-white/10 overflow-hidden">
                <div className="p-6 border-b border-white/10">
                  <div className="flex items-center justify-between">
                    <div>
                      <h2 className="text-xl font-semibold text-white mb-2">
                        {selectedUsers.length === 1
                          ? `${selectedUserData?.username}'s permissions`
                          : `Bulk edit permissions (${selectedUsers.length} users)`}
                      </h2>
                      {selectedUserData && (
                        <div className="flex items-center space-x-4 text-sm text-slate-400">
                          <span className="flex items-center space-x-1">
                            <span>Role:</span>
                            <span className="text-teal-300 font-medium">
                              {selectedUserData.role}
                            </span>
                          </span>
                          <span className="text-slate-600">•</span>
                          <span>
                            Last modified:{" "}
                            {selectedUserData.permissions?.lastModified
                              ? new Date(
                                  selectedUserData.permissions.lastModified,
                                ).toLocaleDateString()
                              : "Never"}
                          </span>
                        </div>
                      )}
                    </div>

                    {selectedUsers.length === 1 && (
                      <div className="flex space-x-3">
                        <button
                          onClick={() => {
                            const originalUser = allUsersPermissions.find(
                              (u) => u.userId === selectedUsers[0],
                            );
                            if (originalUser?.permissions?.menuPermissions) {
                              setLocalPermissions((prev) => ({
                                ...prev,
                                [selectedUsers[0]]:
                                  originalUser.permissions.menuPermissions,
                              }));
                            }
                            setUnsavedChanges((prev) => {
                              const newSet = new Set(prev);
                              newSet.delete(selectedUsers[0]);
                              return newSet;
                            });
                          }}
                          disabled={
                            loading || !unsavedChanges.has(selectedUsers[0])
                          }
                          className="px-4 py-2.5 bg-white/5 hover:bg-red-500/10 hover:text-red-400 text-slate-300 border border-white/20 rounded-lg flex items-center space-x-2 font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <Trash2 className="w-4 h-4" />
                          <span>Cancel</span>
                        </button>
                        <button
                          onClick={() => saveUserPermissions(selectedUsers[0])}
                          disabled={
                            loading || !unsavedChanges.has(selectedUsers[0])
                          }
                          className="px-4 py-2.5 bg-teal-600 hover:bg-teal-700 disabled:bg-white/10 disabled:text-slate-500 text-white rounded-lg flex items-center space-x-2 font-medium transition-all shadow-lg shadow-teal-600/25"
                        >
                          {loading ? (
                            <RefreshCw className="w-4 h-4 animate-spin" />
                          ) : (
                            <Save className="w-4 h-4" />
                          )}
                          <span>Save changes</span>
                        </button>
                        <button
                          onClick={() => resetUserPermissions(selectedUsers[0])}
                          disabled={loading}
                          className="px-4 py-2.5 bg-white/5 hover:bg-red-500/10 hover:text-red-400 text-slate-300 border border-white/20 rounded-lg flex items-center space-x-2 font-medium transition-all"
                        >
                          <Trash2 className="w-4 h-4" />
                          <span>Reset</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="p-6">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/* Standard Menu Items */}
                    {getMenuItemsWithGrouping(availableMenuItems).standard.map(
                      (menuItem) => {
                        const userId = selectedUsers[0];
                        const hasAccess = hasMenuAccess(
                          userId,
                          menuItem.menuId,
                        );

                        return (
                          <div
                            key={menuItem.menuId}
                            className="bg-white/5 rounded-xl border border-white/10 overflow-hidden hover:bg-white/10 transition-all"
                          >
                            <div
                              className="p-4 cursor-pointer"
                              onClick={() =>
                                togglePermission(userId, menuItem.menuId)
                              }
                            >
                              <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`w-6 h-6 rounded-lg flex items-center justify-center ${
                                      hasAccess ? "bg-teal-500" : "bg-white/10"
                                    }`}
                                  >
                                    {hasAccess ? (
                                      <Unlock className="w-4 h-4 text-white" />
                                    ) : (
                                      <Lock className="w-4 h-4 text-slate-400" />
                                    )}
                                  </div>
                                  <span
                                    className={`font-medium ${
                                      hasAccess
                                        ? "text-teal-300"
                                        : "text-slate-300"
                                    }`}
                                  >
                                    {menuItem.label || "Unnamed Menu"}
                                  </span>
                                </div>
                                <div
                                  className={`px-3 py-1 rounded-full text-xs font-medium ${
                                    hasAccess
                                      ? "bg-teal-500/20 text-teal-300"
                                      : "bg-white/5 text-slate-400"
                                  }`}
                                >
                                  {hasAccess ? "Granted" : "Denied"}
                                </div>
                              </div>
                            </div>

                            {menuItem.subMenuPermissions &&
                              Array.isArray(menuItem.subMenuPermissions) &&
                              menuItem.subMenuPermissions.length > 0 && (
                                <div className="border-t border-white/5 bg-white/5">
                                  {menuItem.subMenuPermissions
                                    .filter(
                                      (subMenuItem) =>
                                        subMenuItem && subMenuItem.subMenuId,
                                    )
                                    .map((subMenuItem) => {
                                      const hasSubAccess = hasSubMenuAccess(
                                        userId,
                                        menuItem.menuId,
                                        subMenuItem.subMenuId,
                                      );

                                      return (
                                        <div
                                          key={subMenuItem.subMenuId}
                                          className="px-4 py-3 border-b border-white/5 last:border-b-0 cursor-pointer hover:bg-white/5 transition-all"
                                          onClick={() =>
                                            toggleSubMenuPermission(
                                              userId,
                                              menuItem.menuId,
                                              subMenuItem.subMenuId,
                                            )
                                          }
                                        >
                                          <div className="flex items-center justify-between pl-4">
                                            <div className="flex items-center space-x-3">
                                              <div
                                                className={`w-4 h-4 rounded flex items-center justify-center ${
                                                  hasSubAccess
                                                    ? "bg-teal-500"
                                                    : "bg-white/10"
                                                }`}
                                              >
                                                {hasSubAccess ? (
                                                  <Unlock className="w-3 h-3 text-white" />
                                                ) : (
                                                  <Lock className="w-3 h-3 text-slate-400" />
                                                )}
                                              </div>
                                              <span
                                                className={`text-sm ${
                                                  hasSubAccess
                                                    ? "text-teal-300"
                                                    : "text-slate-400"
                                                }`}
                                              >
                                                {subMenuItem.label ||
                                                  "Unnamed Submenu"}
                                              </span>
                                            </div>
                                            <div
                                              className={`w-2 h-2 rounded-full ${
                                                hasSubAccess
                                                  ? "bg-teal-500"
                                                  : "bg-slate-600"
                                              }`}
                                            ></div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              )}
                          </div>
                        );
                      },
                    )}

                    {/* Customer-Only Menu Items with Disclaimer */}
                    {getMenuItemsWithGrouping(availableMenuItems).customerOnly
                      .length > 0 && (
                      <div className="lg:col-span-2 bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
                        <div className="flex items-start space-x-3 mb-4">
                          <AlertTriangle className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                          <div>
                            <h3 className="text-blue-300 font-semibold mb-1">
                              Customer-Only Permissions
                            </h3>
                            <p className="text-blue-200/70 text-sm">
                              The following permissions are specific to the
                              Customer role and will only be visible when
                              managing Customer users. These are not applicable
                              to Admin, Employee, or Investor roles.
                            </p>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                          {getMenuItemsWithGrouping(
                            availableMenuItems,
                          ).customerOnly.map((menuItem) => {
                            const userId = selectedUsers[0];
                            const hasAccess = hasMenuAccess(
                              userId,
                              menuItem.menuId,
                            );

                            return (
                              <div
                                key={menuItem.menuId}
                                className="bg-white/5 rounded-xl border border-white/10 overflow-hidden hover:bg-white/10 transition-all opacity-75"
                              >
                                <div
                                  className="p-4 cursor-pointer"
                                  onClick={() =>
                                    togglePermission(userId, menuItem.menuId)
                                  }
                                >
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                      <div
                                        className={`w-6 h-6 rounded-lg flex items-center justify-center ${
                                          hasAccess
                                            ? "bg-blue-500"
                                            : "bg-white/10"
                                        }`}
                                      >
                                        {hasAccess ? (
                                          <Unlock className="w-4 h-4 text-white" />
                                        ) : (
                                          <Lock className="w-4 h-4 text-slate-400" />
                                        )}
                                      </div>
                                      <span
                                        className={`font-medium ${
                                          hasAccess
                                            ? "text-blue-300"
                                            : "text-slate-300"
                                        }`}
                                      >
                                        {menuItem.label || "Unnamed Menu"}
                                      </span>
                                    </div>
                                    <div
                                      className={`px-3 py-1 rounded-full text-xs font-medium ${
                                        hasAccess
                                          ? "bg-blue-500/20 text-blue-300"
                                          : "bg-white/5 text-slate-400"
                                      }`}
                                    >
                                      {hasAccess ? "Granted" : "Denied"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessManagement;
